"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var PREFIX = 'ChatIcon';
var classes = {
    main: "".concat(PREFIX, "-main"),
};
var StyledSvgIcon = (0, styles_1.styled)(material_1.SvgIcon)((_a = {},
    _a["&.".concat(classes.main)] = {
        stroke: 'black',
    },
    _a));
var PushPinIcon = function (props) {
    return ((0, jsx_runtime_1.jsxs)(StyledSvgIcon, __assign({ fontSize: "small" }, props, { fill: "none", viewBox: "0 0 24 24", style: __assign({ color: 'transparent' }, props.style), className: (0, classnames_1.default)(classes.main, props.className) }, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M8.25 15.75L4.5 19.5", stroke: "#FF4F6B", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), (0, jsx_runtime_1.jsx)("path", { d: "M14.4699 2.78034L8.62519 8.62501C8.62519 8.62501 6.02419 7.32451 3.24405 9.56724C3.16196 9.63333 3.09468 9.71595 3.0466 9.80974C2.99852 9.90353 2.97071 10.0064 2.96498 10.1116C2.95925 10.2169 2.97572 10.3221 3.01333 10.4206C3.05093 10.519 3.10884 10.6085 3.18327 10.6831L13.2986 20.7984C13.3743 20.8743 13.4655 20.9331 13.5659 20.9708C13.6664 21.0085 13.7737 21.0241 13.8807 21.0167C13.9877 21.0093 14.0919 20.9791 14.1862 20.9279C14.2805 20.8768 14.3627 20.8061 14.4273 20.7204C15.2142 19.6746 16.4501 17.5248 15.3752 15.375L21.2199 9.53034C21.3605 9.38969 21.4395 9.19892 21.4395 9.00001C21.4395 8.8011 21.3605 8.61033 21.2199 8.46968L15.5305 2.78034C15.3899 2.63969 15.1991 2.56067 15.0002 2.56067C14.8013 2.56067 14.6105 2.63969 14.4699 2.78034V2.78034Z", stroke: "#FF4F6B", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] })));
};
exports.default = PushPinIcon;
